module.exports = __webpack_public_path__ + "media/bootstrap-icons/person-c47b10f3.svg";